export default {"src":"/_next/static/media/menu.c4cdac3e.svg","height":12,"width":20,"blurWidth":0,"blurHeight":0};